import Text from '../../../../components/Text'
import Progressbar from '../../../../components/Progressbar'

import Button from '../../../../components/ButtonNew'
import CornerImg from '../../../../assets/images/programs/viemax-program/program-status-flower.svg'
import ArrowRightFilledIcon from '../../../../assets/icons/arrow-right-filled.svg'
import AlarmGif from '../../../../assets/icons/alarm.gif'
import ArrowIcon from '../../../../assets/icons/arrow.svg'
import { supportProgramTypes } from '../../../../constants/support-programs'
import constants from '../../../../constants'
import postMessageToRN from '../../../../utils/helpers/ReactNativeEvents'
import { minDaysToExtendPlan } from '../../../../constants/viemax-constants'
const PlanDetails = ({
  currentProgress,
  totalDays,
  remainingDays,
  viemaxImgUrls,
  onExtendPlan = () => {},
  showExtendPlan = true,
}) => {
  const programName = constants.CARE_PROGRAM_TYPE.VIEMAX
  const handleServicesClick = (service) => {
    if (service.rn_event) {
      postMessageToRN(service.rn_event, service?.navigationData)
    }
  }
  return (
    <>
      <section className="relative z-10 bg-[#F6EDFF] rounded-b-[30px] space-y-6 pt-6">
        {/* Product Display Section */}
        <section className="pb-4">
          <img
            src={viemaxImgUrls.profuctImageWithBg}
            alt="Viemax Success Image"
            className="w-full h-full object-cover"
          />
          <div className="w-full left-0 space-y-4">
            <div className="px-5">
              <div className="bg-white rounded-2xl p-5 shadow-lg w-full relative -top-4">
                <div className="flex flex-col gap-1">
                  <Text variant="body" size="medium" tag="p">
                    Welcome To
                  </Text>
                  <Text variant="title" size="large" tag="p" bold={'true'}>
                    {/* {patientPlan?.plan_name} */}
                    Viemax Club
                  </Text>
                  <div>
                    <Progressbar current={currentProgress} total={totalDays} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>

      <section className="space-y-2 relative -top-[20px] z-[0] bg-[#F2F2F2]">
        {/* Plan Status Section */}
        {showExtendPlan && (
          <div className="bg-[#FFFBEE] px-5 py-6 pt-9 rounded-b-[30px] space-y-3 relative overflow-hidden">
            {remainingDays > minDaysToExtendPlan ? (
              <div className="max-w-[70%] space-y-3">
                <p className="text-[#667085] text-sm">
                  Extend your plan benefits on purchase of every Viemax pack
                </p>
                <button
                  className="text-[#299D6B] text-sm font-medium flex items-center gap-2"
                  onClick={onExtendPlan}
                >
                  <Text
                    variant="label"
                    size="large"
                    tag="p"
                    bold={'true'}
                    className="border-b border-[#299D6B]"
                  >
                    Extend Your Plan
                  </Text>
                  <img
                    src={ArrowIcon}
                    alt="Arrow Right"
                    height={20}
                    width={20}
                  />
                </button>
              </div>
            ) : (
              <div className="max-w-[80%] space-y-3">
                <p className="text-[18px] text-[#B73A3A] font-bold flex items-center gap-1.5">
                  <img src={AlarmGif} alt="Warning" height={28} width={28} />
                  Limited days remaining
                </p>
                <Text
                  variant="body"
                  size="medium"
                  tag="p"
                  className={'text-[#667085]'}
                >
                  Enter your Viemax details to continue availing benefits of
                  this plan
                </Text>

                <Button
                  className="w-full"
                  fullWidth
                  size="small"
                  onClick={onExtendPlan}
                >
                  Extend your program
                </Button>
              </div>
            )}

            <img
              src={CornerImg}
              alt="Corner Image"
              className="absolute bottom-0 right-0"
            />
          </div>
        )}
        {/* Services Section */}
        <div className="bg-[#F2F2F2]">
          <div className="px-5 pb-10 space-y-6 pt-4">
            <Text variant="headline" size="large" tag="p" bold={'true'}>
              Your Services
            </Text>

            <div className="flex flex-col gap-4 mt-4">
              {supportProgramTypes[programName].services.map((service) => (
                <button
                  key={service.name}
                  className="bg-white p-6 rounded-xl shadow-lg flex gap-4 justify-between"
                  onClick={() => {
                    handleServicesClick(service)
                  }}
                >
                  <div className="flex gap-4">
                    <img
                      src={service.icon}
                      alt={service.name}
                      className="w-9 h-9"
                    />
                    <div>
                      <Text variant="body" size="medium" tag="p" bold={'true'}>
                        {service.name}
                      </Text>
                      <Text
                        variant="body"
                        size="small"
                        tag="p"
                        className="text-[#5A6774]"
                      >
                        {service.description}
                      </Text>
                    </div>
                  </div>
                  <img
                    src={ArrowRightFilledIcon}
                    alt={service.name}
                    className="w-5 h-5"
                  />
                </button>
              ))}
            </div>
          </div>
          <img
            src={viemaxImgUrls?.wavyBorder}
            alt="Wavy Border"
            className="w-full h-4"
          />
        </div>
      </section>
    </>
  )
}
export default PlanDetails
